import { ISelectOption } from '@salecycle/ui-component-library';

export const allIataCodes = {
  LHR: 'London Heathrow Airport',
};

export const orderedIataCodeForSelect = (): ISelectOption<string>[] => {
  const allOrderedIataCodes = Object.keys(allIataCodes);
  const valueLabels = [];

  allOrderedIataCodes.forEach(iataCode => {
    if (allIataCodes[iataCode]) {
      valueLabels.push({
        value: iataCode,
        label: `(${iataCode}) ${allIataCodes[iataCode]}`,
      });
    }
  });
  valueLabels.push({ value: 'Unknown', label: 'Unknown (Unknown)' });

  return valueLabels;
};
